import { Badge } from '@/components/design-system'
import { EMPTY, formatCurrency } from '@/frontend/pages/CommandCenter/Organizations/components/organizationFormatting'
import type { BillingPlanRow } from '@/frontend/pages/CommandCenter/Organizations/components/organizationDetailTypes'

interface Props {
  plans: BillingPlanRow[]
}

export default function PlansTable({ plans }: Props) {
  return (
    <section className="rounded-lg border border-border bg-card">
      <div className="border-b border-border px-4 py-3">
        <h3 className="text-base font-semibold text-foreground">Planos usados</h3>
      </div>
      <div className="overflow-auto">
        <table className="w-full">
          <thead className="bg-muted">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground">Plano</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground">Stripe</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground">Preço</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground">Status</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-muted-foreground">Assinaturas</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {plans.map((plan) => (
              <tr key={plan.id}>
                <td className="px-4 py-3">
                  <div className="text-sm font-medium text-foreground">{plan.name}</div>
                  <div className="font-mono text-xs text-muted-foreground">{plan.slug}</div>
                </td>
                <td className="px-4 py-3">
                  <div className="font-mono text-xs text-foreground">{plan.stripe_price_id || EMPTY}</div>
                  <div className="font-mono text-xs text-muted-foreground">{plan.stripe_product_id || EMPTY}</div>
                </td>
                <td className="px-4 py-3 text-sm text-foreground">{formatCurrency(plan.price_cents, plan.currency)}</td>
                <td className="px-4 py-3">
                  <div className="flex flex-wrap gap-1">
                    <Badge tone={plan.published ? 'success' : 'warning'}>{plan.published ? 'Publicado' : 'Oculto'}</Badge>
                    <Badge tone={plan.purchasable ? 'info' : 'attention'}>{plan.purchasable ? 'Checkout' : 'Sem checkout'}</Badge>
                  </div>
                </td>
                <td className="px-4 py-3 text-right text-sm text-foreground">
                  {plan.active_subscriptions_count}/{plan.subscriptions_count}
                </td>
              </tr>
            ))}
            {plans.length === 0 && (
              <tr>
                <td colSpan={5} className="px-4 py-8 text-center text-sm text-muted-foreground">Nenhum plano vinculado.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  )
}
